var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Tipo Documento Legal:",
                  content: _vm.dadosJson.atosLegais.tipoDocumentoLegal || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Instrumento Publicação:",
                  content: _vm.dadosJson.atosLegais.instrumentoPublicacao || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "UF:",
                  content: _vm.dadosJson.contato.estado || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Município:",
                  content: _vm.dadosJson.atosLegais.municipio.id || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Número Documento:",
                  content: _vm.dadosJson.atosLegais.numeroDocumento || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Data Documento:",
                  content:
                    _vm.formatData(_vm.dadosJson.atosLegais.dataDocumento) ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Data Publicação:",
                  content:
                    _vm.formatData(_vm.dadosJson.atosLegais.dataPublicacao) ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Área em Hectares:",
                  content: _vm.dadosJson.atosLegais.areaHectares || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Link Ato Legal:",
                  content: _vm.dadosJson.atosLegais.linkAtoLegal || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Existe Ato Legal ou Complementar:",
                  content:
                    _vm.dadosJson.atosLegais.existeAtoLegalOuComplementar || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Plano Manejo Aprovado:",
                  content: _vm.dadosJson.atosLegais.planoManejoAprovado || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Plano Manejo Tipo Documento:",
                  content: _vm.dadosJson.atosLegais.tipoDocumentoLegal || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Instrumento Publicação Plano Manejo:",
                  content: _vm.dadosJson.atosLegais.instrumentoPublicacao || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "UF Plano Manejo:",
                  content: _vm.dadosJson.contato.estado || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Município Plano Manejo:",
                  content:
                    _vm.dadosJson.atosLegais.municipioPlanoManejo.id || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Número Documento Plano:",
                  content: _vm.dadosJson.atosLegais.numeroDocumento || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Data Documento Plano:",
                  content:
                    _vm.formatData(_vm.dadosJson.atosLegais.dataDocumento) ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Data Publicação Plano:",
                  content:
                    _vm.formatData(_vm.dadosJson.atosLegais.dataPublicacao) ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Link Plano Manejo:",
                  content: _vm.dadosJson.atosLegais.linkPlanoManejo || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Link Plano Manejo Ato Legal:",
                  content:
                    _vm.dadosJson.atosLegais.linkPlanoManejoAtoLegal || "-"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Documento Conselho:",
                  content: _vm.dadosJson.atosLegais.documentoConselho || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Tipo Documento Legal Conselho:",
                  content:
                    _vm.dadosJson.atosLegais.tipoDocumentoLegalConselho || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Instrumento Publicação Conselho:",
                  content:
                    _vm.dadosJson.atosLegais.instrumentoPublicacaoConselho ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "UF Conselho:",
                  content: _vm.dadosJson.contato.estado || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Município Conselho:",
                  content: _vm.dadosJson.atosLegais.municipioConselho.id || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Número Documento Conselho:",
                  content:
                    _vm.dadosJson.atosLegais.numeroDocumentoConselho || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Data Documento Conselho:",
                  content:
                    _vm.formatData(
                      _vm.dadosJson.atosLegais.dataDocumentoConselho
                    ) || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Data Publicação Conselho:",
                  content:
                    _vm.formatData(
                      _vm.dadosJson.atosLegais.dataPublicacaoConselho
                    ) || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Link Plano Manejo Conselho:",
                  content:
                    _vm.dadosJson.atosLegais.linkPlanoManejoConselho || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Outros Instrumentos:",
                  content: _vm.dadosJson.atosLegais.outrosInstrumentos || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Outros Instrumentos Tipo Documento:",
                  content:
                    _vm.dadosJson.atosLegais.outrosInstrumentosTipoDocumento ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Gestão Instrumento Publicação:",
                  content:
                    _vm.dadosJson.atosLegais.gestaoInstrumentoPublicacao || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "UF Gestão:",
                  content: _vm.dadosJson.contato.estado || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Município Gestão:",
                  content: _vm.dadosJson.atosLegais.municipioGestao.id || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Número Documento Plano Gestão:",
                  content:
                    _vm.dadosJson.atosLegais.numeroDocumentoPlanoGestao || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Data Documento Plano Gestão:",
                  content:
                    _vm.formatData(
                      _vm.dadosJson.atosLegais.dataDocumentoPlanoGestao
                    ) || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Data Publicação Gestão:",
                  content:
                    _vm.formatData(
                      _vm.dadosJson.atosLegais.dataPublicacaoGestao
                    ) || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Link Plano Manejo Gestão Ato Legal:",
                  content:
                    _vm.dadosJson.atosLegais.linkPlanoManejoGestaoAtoLegal ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Link Plano Manejo Gestão:",
                  content: _vm.dadosJson.atosLegais.linkPlanoManejoGestao || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Tipo Documento Legal Gestão:",
                  content:
                    _vm.dadosJson.atosLegais.tipoDocumentoLegalGestao || "-"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.documentosAtosLegais
        ? _c("listagem-documentos", {
            attrs: {
              documentos: _vm.documentosAtosLegais,
              protocoloCadastroOriginal: _vm.dadosJson.protocolo,
              ownerDocumento: "ATOS_LEGAIS",
              compararDocumentos: null,
              versaoCadastro: null
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4ca06d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4ca06d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/AtosLegaisUc.vue
// module id = null
// module chunks = 